import { Icon } from '@codex/icons';
import Button from '@dc/ui-library/src/molecules/Button/Button';
import Popup from '@dc/ui-library/src/organisms/Popup/Popup';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const WarnWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 308px;
  padding: 10px;
  margin-bottom:10px;
  border-radius: 3px;
  border: solid 1px #ee9022;
  background-color: #fefaf1;
  font-family: Helvetica;
  font-size: 13px;  
  text-align: left;  
`;

const IconWrap = styled.div`
  color: #e37a00;
`;

const TextWrap = styled.div`
  margin-left: 10px;
`;


export default function AddToBasketFailedPopup(props) {
  return (
    <div className={'AddToBasketFailedPopup'}>
      <Popup
        title={props.popupHeaderLabel}
        isVisible
        optionalClasses={'add-to-basket-failed-popup'}
        onClose={props.onCloseClick}
      >
        <WarnWrapper>
          <IconWrap>
            <Icon icon={'Alert'} size={'large'} />
          </IconWrap>
          <TextWrap>{props.popupMessage}</TextWrap>
        </WarnWrapper>
        <Button onClick={props.onButtonClick}>{props.buttonLabel}</Button>
      </Popup>
    </div>
  );
}


AddToBasketFailedPopup.displayName = 'TariffPopup';

AddToBasketFailedPopup.propTypes = {
  popupHeaderLabel: PropTypes.string.isRequired,
  popupMessage: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  onCloseClick: PropTypes.func
};

AddToBasketFailedPopup.defaultProps = {
  onButtonClick: () => {},
  onCloseClick: () => {}
};
